<script setup lang="ts">
</script>

<template>
  <small class="hd-title-sm">Order Management</small>
  <router-view></router-view>
</template>

<style scoped>

</style>